import { Breakpoints, styled } from '@vw-marketing/us-components';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledQuickActionsContainer: any = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  row-gap: ${(theme: VWTheme) => theme?.size?.static350 || '24px'};
  column-gap: ${(theme: VWTheme) => theme?.size?.static510 || '48px'};
  align-self: center;

  @media (min-width: 375px) {
    grid-template-columns: none;
    grid-template-rows: none;
    row-gap: unset;
    column-gap: unset;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    flex-wrap: nowrap;
    justify-content: center;
    gap: ${(theme: VWTheme) => theme?.size?.static550 || '72px'};
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    gap: ${(theme: VWTheme) => theme?.size?.static510 || '48px'};
  }
`;

export const StyledQuickActionContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 72px;
`;

export const StyledQuickActionTextContainer: any = styled.div`
  font-size: ${(theme: VWTheme) => theme?.size?.static200 || '14px'};

  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static200 || '16px'};
  }

  line-height: ${(theme: VWTheme) =>
    theme?.fonts?.copy?.[200].lineHeight || '24px'};
`;
